import React from 'react';
import { Link } from 'react-router-dom'
import logonew from '../../assets/images/logo.png'
import { useContent } from '../../services'
import analytics from '../../services/analytics'

function Main() {
    const { data: siteData, loading } = useContent('siteContent');

    if (loading || !siteData) return null;

    const { brand, businessInfo, footer, socialLinks } = siteData;

    return (
        <>
            <footer className="main-footer redesigned">

                {/* ── Top Section: 4-Column Grid ── */}
                <div className="footer-upper">
                    <div className="auto-container">
                        <div className="row clearfix">

                            {/* Column 1: Brand + About */}
                            <div className="footer-widget col-lg-4 col-md-6 col-sm-12">
                                <div className="footer-logo">
                                    <Link to="/" title={brand.name}>
                                        <img src={logonew} alt={brand.name} />
                                    </Link>
                                </div>
                                <p className="footer-about-text">
                                    Authentic Mediterranean, Middle Eastern &amp; South Asian cuisine in the heart of Little Elm, Texas. Dine-in, hookah lounge &amp; late-night bites.
                                </p>
                                <div className="footer-social">
                                    {socialLinks.map((link, i) => (
                                        <Link key={i} to={link.url} className="footer-social-icon" aria-label={link.name}
                                            onClick={() => analytics.trackSocialClick(link.name)}>
                                            <i className={link.icon}></i>
                                        </Link>
                                    ))}
                                </div>
                            </div>

                            {/* Column 2: Quick Links */}
                            <div className="footer-widget col-lg-2 col-md-6 col-sm-12">
                                <h4 className="footer-widget-title">Quick Links</h4>
                                <ul className="footer-links-list">
                                    {footer.quickLinks.map((link, i) => (
                                        <li key={i}><Link to={link.path}>{link.label}</Link></li>
                                    ))}
                                    <li><Link to="/reservation">Reservation</Link></li>
                                </ul>
                            </div>

                            {/* Column 3: Contact Info */}
                            <div className="footer-widget col-lg-3 col-md-6 col-sm-12">
                                <h4 className="footer-widget-title">Contact Us</h4>
                                <ul className="footer-contact-list">
                                    <li>
                                        <i className="far fa-map-marker-alt"></i>
                                        <span>{businessInfo.address}</span>
                                    </li>
                                    <li>
                                        <i className="far fa-phone"></i>
                                        <span><Link to={businessInfo.phoneLink} onClick={() => analytics.trackPhoneClick('footer')}>{businessInfo.phone}</Link></span>
                                    </li>
                                    <li>
                                        <i className="far fa-envelope"></i>
                                        <span><Link to={businessInfo.emailLink}>{businessInfo.email}</Link></span>
                                    </li>
                                </ul>
                            </div>

                            {/* Column 4: Opening Hours */}
                            <div className="footer-widget col-lg-3 col-md-6 col-sm-12">
                                <h4 className="footer-widget-title">Opening Hours</h4>
                                <ul className="footer-hours-list">
                                    <li>
                                        <span className="day">Sunday – Thursday</span>
                                        <span className="time">11 AM – 2 AM</span>
                                    </li>
                                    <li>
                                        <span className="day">Friday – Saturday</span>
                                        <span className="time">11 AM – 3 AM</span>
                                    </li>
                                </ul>
                                <div className="footer-newsletter">
                                    <h5 className="newsletter-title">{footer.newsletter.title}</h5>
                                    <form method="post" action="/" className="newsletter-form-inline">
                                        <input type="email" name="email" placeholder="Your email" required />
                                        <button type="submit" aria-label="Subscribe">
                                            <i className="far fa-paper-plane"></i>
                                        </button>
                                    </form>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                {/* ── Bottom Bar ── */}
                <div className="footer-bottom-bar">
                    <div className="auto-container">
                        <div className="footer-bottom-inner">
                            <div className="copyright">
                                &copy; 2026 {brand.shortName}. All Rights Reserved &nbsp;|&nbsp; Designed with <span className="heart">&hearts;</span> by <Link to={footer.copyrightLink} target="_blank" rel="noopener noreferrer">Bogin Tech</Link>
                            </div>
                        </div>
                    </div>
                </div>

            </footer>
            <div className="scroll-to-top scroll-to-target" data-target="html"><span className="icon fa fa-angle-up"></span></div>
        </>
    )
}

export default Main
